/* tslint:disable */
/* eslint-disable */
export enum TimeOfDay {
    Morning = 'Morning',
    Day = 'Day',
    Evening = 'Evening',
    Night = 'Night'
}
